import { KubesoloHostResult, KubesoloTest } from '@api/types.gen';

export const queryKeys = {
  base: () => ['kubesolo', 'connection-tests'] as const,
  active: () => [...queryKeys.base(), 'active'] as const,
  output: (testId: KubesoloTest['id'], hostId: KubesoloHostResult['id']) =>
    [...queryKeys.base(), testId, 'hosts', hostId, 'output'] as const,
  versions: () => ['kubesolo', 'versions'] as const,
  offlineBundles: () => ['kubesolo', 'offline-bundles'] as const,
};
